import { CLICK_ACTION_SOURCE } from '../searchConstants';
import SearchScenarioId from '../store/schema/SearchScenarioId';
import { observer } from 'mobx-react-lite';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import { suggestionSecondaryActionSelected } from 'owa-search';
import { Suggestion } from 'owa-search-service';
import * as React from 'react';
/* tslint:disable:jsx-no-lambda WI:47653 */
import {
    useLivePersonaCard,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';

const styles = require('./PeopleSuggestionQuickActions.scss');

interface PeopleSuggestionPersonaCardProps extends PersonaCardBehaviorProps {
    scenarioId: SearchScenarioId;
    suggestion: Suggestion;
    suggestionSetTraceId: string;
    suggestionIndex: number;
}

export default observer(function PeopleSuggestionPersonaCard(
    props: PeopleSuggestionPersonaCardProps
) {
    const PersonaCardBehavior = useLivePersonaCard(props);

    const { scenarioId, suggestionIndex, suggestion, suggestionSetTraceId } = props;

    return (
        <PersonaCardBehavior>
            <IconButton
                iconProps={{
                    iconName: ControlIcons.ContactCard,
                }}
                className={styles.personaSuggestionIconButton}
                onClick={ev => {
                    suggestionSecondaryActionSelected(
                        suggestion,
                        suggestionIndex,
                        CLICK_ACTION_SOURCE,
                        scenarioId,
                        suggestionSetTraceId,
                        'OpenContactCard' /*EntityActionTakenType*/
                    );
                }}
            />
        </PersonaCardBehavior>
    );
});
